
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
    selector: 'admin-site-notifications-view',
    template: require('./admin.site-notifications.component.html')
})
export class AdminSiteNotificationsViewComponent implements OnInit {
    showSend: boolean = false;
    $state: StateService;

    constructor(
        private stateService: StateService
    ) {
        this.$state = stateService;
    }

    ngOnInit() {
        if (this.stateService.includes('home.admin.sitenotification.send')) {
            this.showSend = true;
        }
    }

}